import { useMemo } from 'react';
import { APPLE, MICROSOFT, GOOGLE, SSO, HUBSPOT, PASSKEY } from '../constants/LoginSources';
export const useLoginRequirementsData = ({
  availableLogins,
  loginRequirementPortalId
}) => {
  return useMemo(() => {
    const isSSOAvailable = availableLogins.indexOf(SSO) !== -1;
    const isGoogleAvailable = availableLogins.indexOf(GOOGLE) !== -1;
    const isMSAvailable = availableLogins.indexOf(MICROSOFT) !== -1;
    const isAppleAvailable = availableLogins.indexOf(APPLE) !== -1;
    const isPasskeyAvailable = availableLogins.indexOf(PASSKEY) !== -1;
    const isPasswordLoginAvailable = availableLogins.indexOf(HUBSPOT) !== -1;
    const isPasswordLoginHidden = isPasswordLoginAvailable && availableLogins.length > 1 || isPasskeyAvailable && availableLogins.length === 1;
    const requiredPortalId = loginRequirementPortalId;
    return {
      isSSOAvailable,
      isGoogleAvailable,
      isMSAvailable,
      isAppleAvailable,
      isPasskeyAvailable,
      isPasswordLoginAvailable,
      isPasswordLoginHidden,
      requiredPortalId
    };
  }, [availableLogins, loginRequirementPortalId]);
};